let concernType = "";
const concernSelectContainer = $('#ContactFormConcernType');
const inputFields = $('#form__contact-us input, #form__contact-us textarea, #form__contact-us select, #form__contact-us button');
const couponBlock = $('#contact__form-coupon-block');
const qualityBlock = $('#contact__form-quality-block');
const stockBlock = $('#contact__form-stock-block');

const stateSelectInput = $('#ContactFormState');

$(document).ready(function() {
  if (stateSelectInput.length) {
    initDropdownContactForm();
  }
})

concernSelectContainer.on('change', function() {
  concernType = this.value;
  couponBlock.hide();
  qualityBlock.hide();
  stockBlock.hide();
  inputFields.each(function() {
    this.disabled = false;
  });

  if (concernType === 'coupon') {
    couponBlock.show();
    inputFields.not(this).each(function() {
      this.disabled = true;
    })
  }
  if (concernType === 'quality') {
    qualityBlock.show();
  }
  if (concernType === 'stock') {
    stockBlock.show();
  }
});
